import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { LoaderProfileService } from '../../services/loader-profile/loader-profile.service';

@Component({
  selector: 'app-loader-profile',
  templateUrl: './loader-profile.component.html',
  styleUrls: ['./loader-profile.component.scss']
})
export class LoaderProfileComponent {
  constructor(private router: Router, private loader: LoaderProfileService) {
    this.redirectToHome();
  }

  redirectToHome() {
    this.loader.hasRoutes$.subscribe((x) => {
      if (!x) {
        return false;
      }
      this.router.navigateByUrl('home');
    });
  }
}
